/**
 * Blog scripts
 *
 * @since 1.0.7
 */

(() => {
	/**
	 * Establish the blog content
	 */
	const blogContent = document.querySelector('.as-blog-content');

	/**
	 * Popup timeout
	 */
	let popupTimeout;


	/**
	 * TOC Mobile Menu
	 */
	const toggleToc = () => {
		// Grab the TOC
		const toc = document.querySelector('.as-blog-sidebar-toc');

		// If the TOC dont exist, get outta here
		if (!toc) {
			return;
		}

		// Now lets toggle the 'expanded' class
		toc.classList.toggle('expanded');
	};


	/**
	 * Copy the URL to the clipboard
	 */
	const copyUrl = () => {
		// Add to the clipboard
		navigator.clipboard.writeText(window.location.href);

		// Get the popup
		const popup = document.querySelector('.as-blog-copy-popup');

		// Show the popup
		popup.classList.add('show');

		// Clear the timeout if it exists
		if (popupTimeout) {
			clearTimeout(popupTimeout);
		}

		// After 3 seconds, hide the popup
		popupTimeout = setTimeout(() => {
			popup.classList.remove('show');
		}, 3000);
	};


	/**
	 * Go to a heading given an element
	 * @param {HTMLElement} heading The heading to scroll to
	 * @returns {void}
	 */
	const goToHeading = (heading) => {
		// No heading? get outta here
		if (!heading) {
			return;
		}

		// The header is 160px tall, so we need to aim up
		const offset = 160;

		// Get the top of the heading
		const top = heading.getBoundingClientRect().top + window.scrollY;

		// Scroll to the heading
		window.scrollTo({
			top: top - offset,
			behavior: 'smooth',
		});

		// Toggle the TOC
		toggleToc();
	};


	/**
	 * Create the table of contents
	 */
	const createToc = () => {
		// Grab the TOC div
		const tocWrapper = document.querySelector('.as-blog-sidebar-toc');

		// Check the wrapper
		if (!tocWrapper) {
			return;
		}

		const toc = tocWrapper.querySelector('ul');

		// None of that? deuces
		if (!toc) {
			return;
		}

		// Get all headings inside the blog content
		const headings = blogContent.querySelectorAll('h2');

		// Keep track of how many headings we've added
		let headingsAdded = 0;

		// Try to get an ID for the heading
		headings.forEach((heading) => {
			// If the heading contains 'See More', skip it
			const headingText = heading.textContent.toLowerCase();

			// If it contains 'see more', skip it
			if (headingText.includes('see more')) {
				return;
			}

			// If the heading already has an ID, use that.
			let id = heading.id;

			// If there is no ID, create one
			if (!id) {
				id = headingText.replace(/[^a-z0-9]/g, '-');
				heading.id = id;
			}

			// Nice, now lets create a list item with a link to the heading
			const li = document.createElement('li');
			const a = document.createElement('a');
			a.href = `#${id}`;
			a.textContent = heading.textContent;

			// Monitor the clicks
			a.addEventListener('click', (e) => {
				e.preventDefault();
				goToHeading(heading);
			});

			// Add the link to the list item
			li.appendChild(a);

			// Add the list item to the TOC
			toc.appendChild(li);

			// Increment the headings added
			headingsAdded++;
		});

		// If there are no headings, hide the TOC
		if (headingsAdded === 0) {
			tocWrapper.remove();
		}
	};


	const countCards = (cards) => {
		cards.forEach((card) => {
			const addCommas = card.dataset.addCommas === 'true';
			const finalNumber = parseFloat(card.dataset.number);
			const isInt = Number.isInteger(finalNumber);
			const duration = 1000;
			const frameRate = 60;
			const totalFrames = Math.round((duration / 1000) * frameRate);
			let frame = 0;

			const startNumber = 0;
			const increment = (finalNumber - startNumber) / totalFrames;

			const animate = () => {
				frame++;
				let current = startNumber + increment * frame;
				if (frame >= totalFrames) {
					current = finalNumber;
				}

				if (addCommas) {
					card.textContent = current.toLocaleString(undefined, { maximumFractionDigits: isInt ? 0 : 2 });
				} else {
					if (isInt) {
						card.textContent = Math.round(current);
					} else {
						card.textContent = current.toFixed(2);
					}
				}

				if (frame < totalFrames) {
					requestAnimationFrame(animate);
				} else {
					if (addCommas) {
						card.textContent = finalNumber.toLocaleString(undefined, { maximumFractionDigits: isInt ? 0 : 2 });
					} else {
						if (isInt) {
							card.textContent = Math.round(finalNumber);
						} else {
							card.textContent = finalNumber.toFixed(2);
						}
					}
				}
			};

			animate();
		});
	};


	/**
	 * Count up the cards when they are in view
	 * @param {*} countUpCards The count up cards element
	 * @returns {void}
	 */
	const handleCountUpCards = (countUpCards) => {
		// Grab the numbers
		const cards = countUpCards.querySelectorAll('.as-blog-count-up-number');

		// If this is false or the cards are empty, get outta here
		if (!cards || cards.length === 0) {
			return;
		}

		// Grab the first card
		const firstCard = cards[0];

		// Lets write a quick function to count the cards that we can add to a scroll event
		const checkCardInView = () => {
			if (firstCard.getBoundingClientRect().top < window.innerHeight && firstCard.getBoundingClientRect().bottom > 0) {
				countCards(cards);
				window.removeEventListener('scroll', checkCardInView);
			}
		};


		// If the card is in view, we can start counting
		if (firstCard.getBoundingClientRect().top < window.innerHeight && firstCard.getBoundingClientRect().bottom > 0) {
			countCards(cards);
		} else {
			// If not, lets add an event listener to the window to check when the card is in view
			window.addEventListener('scroll', checkCardInView);
		}
	};


	/**
	 * Clean up the blog content
	 * @returns {void}
	 */
	const cleanBlog = () => {
		// If blog content is empty, lets just go ahead and bounce
		if (!blogContent) {
			return;
		}

		// Grab the first and last element
		const firstElement = blogContent.firstElementChild;
		const lastElement = blogContent.lastElementChild;

		// Remove the top margin from the first element
		firstElement.style.marginTop = '0';

		// Remove the bottom margin from the last element
		lastElement.style.marginBottom = '0';
	};


	// Create the table of contents
	createToc();

	// Watch the TOC mobile button
	const tocButton = document.querySelector('.as-blog-sidebar-toc-toggle');

	// If the button exists, monitor the click
	if (tocButton) {
		tocButton.addEventListener('click', toggleToc);
	}

	// Monitor the click to copy article URL button
	const copyUrlButton = document.querySelector('#as-blog-copy-article');

	// If the button exists, monitor the click
	if (copyUrlButton) {
		copyUrlButton.addEventListener('click', copyUrl);
	}

	// Handle the count up cards on the blog
	const countUpCards = document.querySelector('.as-blog-count-ups');

	// If they exist, lets count them up
	if (countUpCards) {
		handleCountUpCards(countUpCards);
	}

	// Clean up blog
	cleanBlog();

})();